import { config } from 'src/config'
import { POST_TYPE_BLOG_POST } from 'src/constants'
import { getLanguageFromLocale } from 'src/functions/i18n/localeFns'

import type { Locale } from 'src/enum/Locale'
import type { PostType } from 'src/types/Post'

export const getPostUrl = (postSlug: string, locale: Locale, postType: PostType): string => {
  const language = getLanguageFromLocale(locale)

  // is it a "/b/", or an "/e/" page?
  const pagePrefix = postType === POST_TYPE_BLOG_POST ? 'b' : 'e'

  return `${config.host}/${language}/${pagePrefix}/${postSlug}`
}
